import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const title = css`
  margin: 0;
  color: var(--neutral-black-base);
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${theme.responsiveText.HEADING.XS};
`;

export const intro = css`
  ${theme.responsiveText.BODY.MD};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  margin: ${spacing.md}px 0;
`;

export const container = css`
  text-align: center;
  padding: ${spacing.md}px 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.xxl}px 0;
    `,
  )};
`;
